import { render, staticRenderFns } from "./top-bot-layout.vue?vue&type=template&id=725ab499&scoped=true&"
import script from "./top-bot-layout.vue?vue&type=script&lang=ts&"
export * from "./top-bot-layout.vue?vue&type=script&lang=ts&"
import style0 from "./top-bot-layout.vue?vue&type=style&index=0&id=725ab499&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725ab499",
  null
  
)

export default component.exports